var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#57B3CB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-680v-160l160 80-160 80Zm600 0v-160l160 80-160 80Zm-280-40v-160l160 80-160 80Zm0 640q-76-2-141.5-12.5t-114-26.5Q136-135 108-156t-28-44v-360q0-25 31.5-46.5t85.5-38q54-16.5 127-26t156-9.5q83 0 156 9.5t127 26q54 16.5 85.5 38T880-560v360q0 23-28 44t-76.5 37q-48.5 16-114 26.5T520-80v-160h-80v160Zm40-440q97 0 167.5-11.5T760-558q0-5-76-23.5T480-600q-128 0-204 18.5T200-558q42 15 112.5 26.5T480-520ZM360-166v-154h240v154q80-8 131-23.5t69-27.5v-271q-55 22-138 35t-182 13q-99 0-182-13t-138-35v271q18 12 69 27.5T360-166Zm120-161Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjNTdCM0NCIj48cGF0aCBkPSJNMTIwLTY4MHYtMTYwbDE2MCA4MC0xNjAgODBabTYwMCAwdi0xNjBsMTYwIDgwLTE2MCA4MFptLTI4MC00MHYtMTYwbDE2MCA4MC0xNjAgODBabTAgNjQwcS03Ni0yLTE0MS41LTEyLjV0LTExNC0yNi41UTEzNi0xMzUgMTA4LTE1NnQtMjgtNDR2LTM2MHEwLTI1IDMxLjUtNDYuNXQ4NS41LTM4cTU0LTE2LjUgMTI3LTI2dDE1Ni05LjVxODMgMCAxNTYgOS41dDEyNyAyNnE1NCAxNi41IDg1LjUgMzhUODgwLTU2MHYzNjBxMCAyMy0yOCA0NHQtNzYuNSAzN3EtNDguNSAxNi0xMTQgMjYuNVQ1MjAtODB2LTE2MGgtODB2MTYwWm00MC00NDBxOTcgMCAxNjcuNS0xMS41VDc2MC01NThxMC01LTc2LTIzLjVUNDgwLTYwMHEtMTI4IDAtMjA0IDE4LjVUMjAwLTU1OHE0MiAxNSAxMTIuNSAyNi41VDQ4MC01MjBaTTM2MC0xNjZ2LTE1NGgyNDB2MTU0cTgwLTggMTMxLTIzLjV0NjktMjcuNXYtMjcxcS01NSAyMi0xMzggMzV0LTE4MiAxM3EtOTkgMC0xODItMTN0LTEzOC0zNXYyNzFxMTggMTIgNjkgMjcuNVQzNjAtMTY2Wm0xMjAtMTYxWiIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };